module.exports = __webpack_public_path__ + "img/thumb-video-3.b8829a06.png";